/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react';

import { params } from '../../../../../redux/reducers/reducer';
import { convertFeet } from '../../../../../utils/ConvertFeet';

import LineModel from '../../LineModel';
import DimensionValue from '../../DimensionValue';

const GableBackLeanToMeasurement = ({ color }) => {
    const [arrowPositions, setArrowPositions] = useState({
        widthArrowSize: 0,
        widthArrowPos: [0, 0, 0],
        lengthArrowSize: 0,
        leftLengthArrowPos: [0, 0, 0],
        rightLengthArrowPos: [0, 0, 0],
        heightArrowSize: 0,
        leftHeightArrowPos: [0, 0, 0],
        rightHeightArrowPos: [0, 0, 0],
    });

    const arrowOffset = 0.3;
    const offset = 0.2;

    useMemo(() => {
        const {leanB_p_d, leanB_p_w, leanB_p_h, p_d} = params;
        const alignPosOffset = 0;
        let newArrowPositions = {};
        newArrowPositions = {
            widthArrowSize: leanB_p_w /* + 0.4 */,//->SE3-I6164 ->Dimension isn't coming correct for secondary building//
            widthArrowPos: [alignPosOffset, arrowOffset - 0.1, -(p_d / 2 + leanB_p_d + arrowOffset)],
            lengthArrowSize: leanB_p_d,
            leftLengthArrowPos: [-(leanB_p_w / 2 + offset) + alignPosOffset, 0, -(p_d / 2 + leanB_p_d / 2 + arrowOffset)],
            rightLengthArrowPos: [(leanB_p_w / 2 + offset) + alignPosOffset, 0, -(p_d / 2 + leanB_p_d / 2 + arrowOffset)],
            heightArrowSize: leanB_p_h,
            leftHeightArrowPos: [-(leanB_p_w / 2 + offset) + alignPosOffset, leanB_p_h / 2, -(p_d / 2 + leanB_p_d + arrowOffset)],
            rightHeightArrowPos: [(leanB_p_w / 2 + offset) + alignPosOffset, leanB_p_h / 2, -(p_d / 2 + leanB_p_d + arrowOffset)],
        };
        setArrowPositions(newArrowPositions);
    }, [ params.p_d, params.leanB_p_w, params.leanB_p_d, params.leanB_p_h ]);

    const { 
        widthArrowSize, widthArrowPos, lengthArrowSize, 
        leftLengthArrowPos, rightLengthArrowPos, heightArrowSize, 
        leftHeightArrowPos, rightHeightArrowPos 
    } = arrowPositions;


    return params.add_back_lean && (
        <group name='Measurements-gableBackLeanto'>
            {/* width */}
            <group name='back-arrow' position={widthArrowPos}>
                <LineModel length={widthArrowSize} rotation={[0, 0, Math.PI / 2]} color={color} />
                <DimensionValue position={[0, 0, -0.4]} rotation={[0, Math.PI, 0]} value={`${convertFeet(widthArrowSize,false)} L`} slopeAngle={25} type={'lean'} cmpPos={widthArrowPos} />
            </group>

            {/* length */}
            <group name='left-arrow' position={leftLengthArrowPos}>
                <LineModel length={lengthArrowSize} position={[0, 0.2, 0]} rotation={[Math.PI / 2, 0, 0]} color={color} />
                <DimensionValue position={[0, 0, 0]} rotation={[0, -Math.PI / 2, 0]} value={`${convertFeet(lengthArrowSize,false)} W`} slopeAngle={25} type={'lean'} cmpPos={leftLengthArrowPos} />
            </group>
            <group name='right-arrow' position={rightLengthArrowPos}>
                <LineModel length={lengthArrowSize} position={[0, 0.2, 0]} rotation={[Math.PI / 2, 0, 0]} color={color} />
                <DimensionValue position={[0, 0, 0]} rotation={[0, Math.PI / 2, 0]} value={`${convertFeet(lengthArrowSize,false)} W`} slopeAngle={25} type={'lean'} cmpPos={rightLengthArrowPos} />
            </group>

            {/* height */}
            <group name='left-arrow' position={leftHeightArrowPos} rotation={[0, -Math.PI / 2, 0]}>
                <LineModel length={heightArrowSize - 0.2} color={color} position={[0, 0.08, 0]} />
                <DimensionValue position={[-[...`${convertFeet(heightArrowSize)} H`].length * 0.2, 0, offset]} rotation={[0, Math.PI, 0]} value={`${convertFeet(heightArrowSize,false)} H`} slopeAngle={0} type={'lean'} checkBackSide={true} cmpPos={leftHeightArrowPos} />
            </group>
            <group name='right-arrow' position={rightHeightArrowPos}>
                <LineModel length={heightArrowSize - 0.2} color={color} position={[0, 0.08, 0]} />
                <DimensionValue position={[[...`${convertFeet(heightArrowSize)} H`].length * 0.2, 0, offset]} rotation={[0, Math.PI, 0]} value={`${convertFeet(heightArrowSize,false)} H`} slopeAngle={0} type={'lean'} checkBackSide={true} cmpPos={rightHeightArrowPos} />
            </group>
        </group>
    );
};

export default GableBackLeanToMeasurement;
